import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';
import { downloadGradient } from '../utils/downloadUtils';
import { MeshGradient } from '../types';
import { playPopSound } from '../utils/soundUtils';

interface DownloadButtonProps {
  gradient: MeshGradient;
}

export function DownloadButton({ gradient }: DownloadButtonProps) {
  const { isDarkMode } = useTheme();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleDownload = async (ratio: '1:1' | '16:9') => {
    playPopSound('medium'); // Play sound effect
    await downloadGradient(gradient, ratio);
    setIsDropdownOpen(false);
  };

  return (
    <div className="relative">
      <button 
        onClick={() => {
          playPopSound('soft'); // Play sound effect
          setIsDropdownOpen(!isDropdownOpen);
        }}
        className={`flex items-center space-x-2 p-2 rounded-lg bg-white/10 backdrop-blur-sm 
          hover:bg-white/20 transition-all duration-300 hover:scale-105 active:scale-95`}
      >
        <Download size={20} className="text-white" />
      </button>

      {isDropdownOpen && (
        <div className={`absolute right-0 mt-2 w-32 rounded-lg shadow-lg ${
          isDarkMode ? 'bg-gray-800' : 'bg-white'
        } ring-1 ring-black ring-opacity-5 z-50 transform transition-all duration-200 origin-top-right`}>
          <div className="py-1">
            <button
              onClick={() => handleDownload('1:1')}
              className={`block w-full text-left px-4 py-2 text-sm transition-all duration-200 ${
                isDarkMode 
                  ? 'text-gray-200 hover:bg-gray-700 hover:text-white' 
                  : 'text-gray-700 hover:bg-gray-100 hover:text-black'
              } hover:translate-x-1`}
            >
              Square (1:1)
            </button>
            <button
              onClick={() => handleDownload('16:9')}
              className={`block w-full text-left px-4 py-2 text-sm transition-all duration-200 ${
                isDarkMode 
                  ? 'text-gray-200 hover:bg-gray-700 hover:text-white' 
                  : 'text-gray-700 hover:bg-gray-100 hover:text-black'
              } hover:translate-x-1`}
            >
              Landscape (16:9)
            </button>
          </div>
        </div>
      )}
    </div>
  );
}